import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../css/PasswordInput.css";

const PasswordInput = ({
  placeholder,
  value,
  onChange,
  custom,
  label,
  star,
}) => {
  const [showPassword, setShowPassword] = useState(
    label === "Confirm Password" ? true : false
  );

  const showPasswordHandler = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div
      className={`${custom ? "custom-input-field" : "password-input"} relative`}
    >
      <label>
        {label} {star && <span className="text-red-500">*</span>}
      </label>
      <input
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <span
        onClick={showPasswordHandler}
        style={{ cursor: "pointer" }}
        className="absolute right-3 bottom-3"
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>
  );
};

export default PasswordInput;
